(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sesh-routine-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-sesh-routine-add]');
  if (!button || button.disabled) return;
  const ids = (button.dataset.variants || '').split(',').filter(Boolean);
  if (!ids.length) return;
  const items = ids.map(function(id) {
    return { id: Number(id), quantity: 1 };
  });
  const original = button.dataset.defaultLabel || button.textContent;
  button.disabled = true;
  button.textContent = button.dataset.addingLabel || original;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!response.ok) throw new Error('cart');
    window.location.assign(button.dataset.cartUrl || (window.Shopify.routes.root + 'cart'));
  } catch (error) {
    button.disabled = false;
    button.textContent = original;
  }
});

  } catch(e) { console.error(e); }
})();
})();
